<div class="popup" [class.popup__warning]="data.status === PopupStatus.Warning" [class.popup__error]="data.status === PopupStatus.Error">
  @if (data.isError) {
    <div class="popup__error">
      An error has been logged, you can use the icon to copy this information to the clipboard and include it if contacting ComReg:
    </div>
  }

  <div class="popup__message">
    <div class="popup__message__title">
      <mat-icon>warning</mat-icon>
      @if (data.header) {
        <h3>{{ data.header }}</h3>
      } @else {
        <h3>Information</h3>
      }
    </div>

    @if (isArray(data.message)) {
      <ul>
        @for (line of data.message; track $index) {
          <li>{{ line }}</li>
        }
      </ul>
    } @else {
      <span matSnackBarLabel>{{ data.message }}</span>
    }
    @if (data.uuid ?? null !== null) {
      <div class="popup__uuid">[{{ data.uuid }}]</div>
    }
  </div>

  <div class="popup__actions">
    @if (data.showCopy) {
      <button (click)="snackBarRef.dismissWithAction()" matSnackBarAction mat-icon-button aria-label="Copy and close">
        <span class="material-symbols-outlined">content_copy</span>
      </button>
    }

    <button (click)="snackBarRef.dismiss()" matSnackBarAction mat-icon-button aria-label="Close">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>
</div>
